import { render, staticRenderFns } from "./orderTag.vue?vue&type=template&id=21846164&scoped=true&"
import script from "./orderTag.vue?vue&type=script&lang=js&"
export * from "./orderTag.vue?vue&type=script&lang=js&"
import style0 from "./orderTag.vue?vue&type=style&index=0&id=21846164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21846164",
  null
  
)

export default component.exports